<template>
  <div class="mainBox" id="courseTable">
    <template v-if="myLeassonData && myLeassonData.length > 0">
      <div v-for="(item, i) in myLeassonData" :key="i" class="year-section">
        <div class="title-wrapper">
          <h1>{{ item.yearXq }}</h1>
          <span v-if="i === 0">
            <Button
              type="info"
              size="small"
              class="select-all-button pay-button"
              @click="selectAll"
              style="font-size: 18px; margin-right: 10px;"
              >全选</Button
            >
            <Button
              type="info"
              size="small"
              :disabled="isdisabledFn"
              @click="getPay()"
              class="pay-button"
              style="font-size: 18px;"
              >付款</Button
            >
          </span>
        </div>

        <!-- PC端表格 -->
        <div class="pc-table">
          <Table
            size="large"
            @on-selection-change="changhePay"
            ref="selectionPay"
            :columns="courseColumns"
            :data="item.myCourselist"
            stripe
          ></Table>
        </div>

        <!-- 移动端卡片列表 -->
        <div class="mobile-list">
          <div v-for="(course, index) in item.myCourselist" :key="index" class="course-card">
            <div class="course-header">
              <Checkbox 
                v-model="course.selected" 
                @on-change="(val) => handleMobileSelection(val, course)"
                :disabled="course._disabled"
              ></Checkbox>
              <span class="course-name">{{course.course}}</span>
            </div>
            <div class="course-info">
              <div class="info-item">
                <span class="label">任课老师:</span>
                <span class="value">{{course.teacher}}</span>
              </div>
              <div class="info-item">
                <span class="label">开课时间:</span>
                <span class="value">{{course.beginDt}}</span>
              </div>
              <div class="info-item">
                <span class="label">上课时间:</span>
                <span class="value">{{course.classBegin}}</span>
              </div>
              <div class="info-item">
                <span class="label">上课地点:</span>
                <span class="value">{{course.address}}</span>
              </div>
              <div class="info-item">
                <span class="label">学费:</span>
                <span class="value">{{course.amount}}</span>
              </div>
              <div class="info-item">
                <span class="label">状态:</span>
                <span class="value">{{
                  course.orderStatus == "0"
                    ? "待审核"
                    : course.orderStatus == "1"
                    ? "待缴费"
                    : course.orderStatus == "2"
                    ? "已缴费"
                    : course.orderStatus == "3"
                    ? "已退款"
                    : course.orderStatus == "4"
                    ? "已逾期"
                    : course.orderStatus == "5"
                    ? "退课中"
                    : course.orderStatus == "6"
                    ? "已退课"
                    : course.orderStatus == "7"
                    ? "已取消"
                    : ""
                }}</span>
              </div>
            </div>
            <div class="course-actions">
              <Button
                type="info"
                size="small"
                v-if="course.courseInvalidInd == null"
                @click="() => {
                  $router.push({ 
                    name: 'detail', 
                    query: {
                      id: course.id,
                      sid: baseInfo.sid,
                      studentId: $store.state.studentId,
                      courseNo: course.courseNo,
                      year: course.year,
                      xq: course.xq
                    }
                  });
                }"
              >查看详情</Button>
              <Button
                type="info"
                size="small"
                v-if="course.orderStatus == 1"
                @click="() => cancelCourse(course.orderId)"
              >取消待缴费课程</Button>
              <Button
                type="info"
                size="small"
                v-if="course.orderStatus == 1 && course.payEndDate != null"
                @click="() => {
                  payData = [];
                  billno = course.orderNo;
                  payData.push(course);
                  totAmount = parseFloat(course.amount).toFixed(2);
                  visiblePayMsg = true;
                }"
              >付款</Button>
              <Button
                type="info"
                size="small"
                v-if="course.orderStatus == 2"
                @click="() => viewInvoice(course.orderNo)"
              >管理发票</Button>
              <!-- 注释掉退课按钮
              <Button
                type="info"
                size="small"
                v-if="course.orderStatus == 2 && item.isRefund == '1'"
                @click="() => openDropCourse(course)"
              >退课</Button>
              -->
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div style="text-align: center; padding: 20px;">
        <p>暂无课程数据</p>
      </div>
    </template>

    <!-- 退课原因  strat-->
    <Modal
      v-model="tKCourseModal"
      title="退课原因"
      footer-hide
      :width="modalWidth"
      class-name="tui-tk-modal"
    >
      <Form
        ref="tKCourseForm"
        :model="tKCourseForm"
        :rules="tKCourseFormRules"
        :label-width="formLabelWidth"
        :label-position="labelPosition"
      >
        <FormItem label="原因：" prop="refundReason">
          <Input
            type="textarea"
            :maxlength="30"
            v-model="tKCourseForm.refundReason"
            placeholder="请输入原因"
          ></Input>
        </FormItem>
        <FormItem label="上传证明材料：" prop="imageNames">
          <div class="tui-upload-wrap">
            <div class="demo-upload-list" v-for="item in tKUploadList" :key="item.name">
              <template v-if="item.status == 'finished'">
                <img :src="item.url" />
                <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" @click.native="tKHandleView(item.url)"></Icon>
                  <Icon type="ios-trash-outline" @click.native="tKHandleRemove(item)"></Icon>
                </div>
              </template>
              <template v-else>
                <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
              </template>
            </div>
            <Upload
              :action="'/retireSystem/retire-manage/S3/uploadImage'"
              :show-upload-list="false"
              name="file"
              :on-success="tKHandleSuccess"
              :format="['jpg', 'jpeg', 'png']"
              :max-size="2048"
              :before-upload="tKHandleBeforeUpload"
              :multiple="true"
              type="select"
              class="tui-uploader"
              :headers="uploadHeaders">
              <div class="tui-upload-btn">
                <Icon type="ios-camera" size="20"></Icon>
                <span class="tui-upload-text">上传图片</span>
              </div>
            </Upload>
          </div>
        </FormItem>

        <FormItem class="tui-form-actions">
          <Button type="primary" @click="dropCourse" class="tui-action-btn tui-action-primary">提交</Button>
          <Button @click="tKCourseModal = false" class="tui-action-btn tui-action-cancel">取消</Button>
        </FormItem>
        <!-- <FormItem>
          <div style="text-align: left; font-size: 20px; color: red">
            <p>
              提交退费申请后，您将收到老年大学的电话确认（以下电话号码其中之一：65987820；55038367；51030789），请务必接听。
            </p>
          </div>
        </FormItem> -->
      </Form>
    </Modal>
    <!-- 退课原因 end-->

    <Modal
      title="修改发票抬头(您的发票还未开具，在此可更改发票抬头)"
      v-model="visibleInvoiceMsg"
      width="80%"
      :mask-closable="false"
    >
      <my-Invoice
        v-if="visibleInvoiceMsg"
        ref="invoiceForm"
        :invoiceData="this.viewInvoiceData"
      ></my-Invoice>
      <!-- 底部按钮 -->
      <template #footer>
        <div class="tui-modal-footer">
          <Button type="primary" @click="updateInvoiceTitle" class="tui-action-btn tui-action-primary">更新</Button>
          <Button @click="visibleInvoiceMsg = false" class="tui-action-btn tui-action-cancel">取消</Button>
        </div>
      </template>
    </Modal>

    <!-- 付款  strat-->
    <ApplyModal
      :visible-pay-msg="visiblePayMsg"
      :pay-data="payData"
      type="myLeasson"
      @changeVisiblePayMsg="(value) => (visiblePayMsg = value)"
    ></ApplyModal>
    <!-- 付款 end-->
  </div>
</template>
<script>
import ApplyModal from "_c/applyModal.vue";
import myInvoice from "@/views/myAccount/myInvoice.vue";

export default {
  data() {
    return {
      payData: [],
      myLeassonData: [],
      baseInfo: [],
      billno: "",
      totAmount: 0,
      isdisabledFn: true,
      tKCourseModal: false,
      visiblePayMsg: false,
      visibleInvoiceMsg: false,
      billVisibleInvoiceMsg: false,
      isAllSelected: false,
      isMobile: false,
      courseColumns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left"
        },
        {
          title: "课程名称",
          key: "course",
          minWidth: 200,
          ellipsis: true,
          tooltip: true
        },
        {
          title: "任课老师",
          key: "teacher",
          minWidth: 100,
          ellipsis: true,
          tooltip: true
        },
        {
          title: "开课时间",
          key: "beginDt",
          minWidth: 100,
          ellipsis: true,
          tooltip: true
        },
        {
          title: "上课时间",
          key: "classBegin",
          minWidth: 100,
          ellipsis: true,
          tooltip: true
        },
        {
          title: "上课地点",
          key: "address",
          minWidth: 200,
          ellipsis: true,
          tooltip: true
        },
        {
          title: "学费",
          key: "amount",
          minWidth: 80,
          ellipsis: true,
          tooltip: true
        },
        {
          title: "状态",
          key: "orderStatus",
          minWidth: 80,
          ellipsis: true,
          tooltip: true,
          render: (h, params) => {
            const text =
              params.row.orderStatus == "0"
                ? "待审核"
                : params.row.orderStatus == "1"
                ? "待缴费"
                : params.row.orderStatus == "2"
                ? "已缴费"
                : params.row.orderStatus == "3"
                ? "已退款"
                : params.row.orderStatus == "4"
                ? "已逾期"
                : params.row.orderStatus == "5"
                ? "退课中"
                : params.row.orderStatus == "6"
                ? "已退课"
                : params.row.orderStatus == "7"
                ? "已取消"
                : "";
            return h("span", text);
          }
        },
        {
          title: "操作",
          key: "action",
          minWidth: 200,
          fixed: "right",
          render: (h, params) => {
            let pay = params.row.orderStatus != "1" || params.row.payEndDate == null;
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "dashed",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  directives: [
                    {
                      name: "show",
                      value: params.row.courseInvalidInd == null
                    }
                  ],
                  on: {
                    click: () => {
                      this.$router.push({
                        name: "detail",
                        query: {
                          id: params.row.id,
                          sid: this.baseInfo.sid,
                          studentId: this.$store.state.studentId,
                          courseNo: params.row.courseNo,
                          year: params.row.year,
                          xq: params.row.xq
                        }
                      });
                    }
                  }
                },
                "查看详情"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "dashed",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  directives: [
                    {
                      name: "show",
                      value: params.row.orderStatus == 1
                    }
                  ],
                  on: {
                    click: () => {
                      this.cancelCourse(params.row.orderId);
                    }
                  }
                },
                "取消待缴费课程"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "dashed",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  directives: [
                    {
                      name: "show",
                      value: !pay
                    }
                  ],
                  on: {
                    click: () => {
                      this.payData = [];
                      this.billno = params.row.orderNo;
                      this.payData.push(params.row);
                      this.totAmount = parseFloat(params.row.amount).toFixed(2);
                      this.visiblePayMsg = true;
                    }
                  }
                },
                "付款"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "dashed",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  directives: [
                    {
                      name: "show",
                      value: params.row.orderStatus == 2
                    }
                  ],
                  on: {
                    click: () => {
                      this.viewInvoice(params.row.orderNo);
                    }
                  }
                },
                "管理发票"
              ),
              // 注释掉退课按钮
              // h(
              //   "Button",
              //   {
              //     props: {
              //       type: "dashed",
              //       size: "small"
              //     },
              //     style: {
              //       marginRight: "5px"
              //     },
              //     directives: [
              //       {
              //         name: "show",
              //         value: this.canDropCourse(params.row)
              //       }
              //     ],
              //     on: {
              //       click: () => {
              //         this.openDropCourse(params.row);
              //       }
              //     }
              //   },
              //   "退课"
              // )
            ]);
          }
        }
      ],
      tKCourseForm: {
        id: "",
        refundReason: "",
        orderId: "",
        imageNames: ""
      },
      tKUploadList: [],
      uploadHeaders: {
        token: sessionStorage.getItem('token_retire_school'),
      },
      tKCourseFormRules: {
        refundReason: [
          { required: true, message: "原因不能为空", trigger: "blur" },
        ],
        imageNames: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const finished = (this.tKUploadList || []).filter(
                (it) => it.status === "finished"
              );
              if (finished.length > 0) {
                callback();
              } else {
                callback(new Error("请上传图片"));
              }
            },
            trigger: "change",
          },
        ],
      },
      upINVForm: {
        courseId: "",
        INVURl: "",
        invoiceNo: "",
        invoiceDt: "",
        year: "",
        xq: "",
      },
      upINVFormRules: {
        invoiceNo: [
          { required: true, message: "发票号码不能为空", trigger: "blur" },
        ],
        invoiceDt: [
          { required: true, message: "开票时间不能为空", trigger: "change" },
        ],
      },
      upINVModal: false,
      courseData: [],
    };
  },
  components: {
    ApplyModal,
    myInvoice,
  },
  methods: {
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    getCourseData() {
      var _this = this;
      
      // 初始化数据
      _this.myLeassonData = [];
      
      _this.$http
        .get("retire-school-manage/personal/getMyCourse", {
          params: {
            studentId: _this.$store.state.studentId,
          },
        })
        .then((res) => {
          if (res.data.status === 2000) {
            _this.myLeassonData = res.data.data || [];
            
            if (_this.myLeassonData.length > 0) {
              _this.myLeassonData.forEach((semester, i) => {
                if (semester.myCourselist) {
                  semester.myCourselist.forEach(course => {
                course.selected = false;
                course._disabled = course.orderStatus != 1 || course.payEndDate == null;
              });
                }
              });
            }
          } 
        })
        .catch(function (error) {
          _this.$Message.error('获取数据失败');
        });
    },
    potsINV() {
      //上传发票
      this.$refs.upINVForm.validate((valid) => {
        if (valid) {
          var _this = this;
          _this.$http
            .get("retire-school-manage/subsidy/checkInvoiceNo", {
              params: {
                invoiceNo: _this.upINVForm.invoiceNo,
                // invoiceDt: _this.upINVForm.invoiceDt,
                // course:_this.upINVForm.course,
                // fileSrc:_this.upINVForm.INVURl,
                // invoiceNo:_this.upINVForm.invoiceNo
              },
            })
            .then((res) => {
              if (res.data.status == 2000) {
                _this.$http
                  .post(
                    "retire-school-manage/subsidy/applySchoolSubsidy?studentId=" +
                      _this.$store.state.studentId +
                      "&courseId=" +
                      _this.upINVForm.courseId +
                      "&fileSrc=" +
                      _this.upINVForm.INVURl +
                      "&invoiceNo=" +
                      _this.upINVForm.invoiceNo +
                      "&invoiceDt=" +
                      _this.upINVForm.invoiceDt +
                      "&year=" +
                      _this.upINVForm.year +
                      "&xq=" +
                      _this.upINVForm.xq
                  )
                  .then((res) => {
                    if (res.data.status == 2000) {
                      _this.$refs.upload.clearFiles(); //上传成功后清除记录
                      _this.getCourseData();
                      _this.upINVModal = false;
                      _this.$CustomMessageInfo("提交申请成功!");
                    } else {
                      _this.$CustomMessageError(res.data.msg);
                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                  });
              } else {
                _this.$CustomMessageError("发票已重复，请重新上传！");
              }
            });
        }
      });
    },
    addFinceUploadSuccess(res, file) {
      this.upINVForm.INVURl = res.data.url;
      // this.$refs.upload.clearFiles(); //上传成功后清除记录
    },
    getPay() {
      this.visiblePayMsg = true;
    },

    sendNotice(msg) {
      var _this = this;
      if (_this.$store.state.studentId) {
        _this.$http
          .post("retire-school-manage/notice/addSchoolNotice", {
            studentId: _this.$store.state.studentId,
            content: msg,
          })
          .then(function (res) {
            if (res.data.status != 2000) {
              _this.$CustomMessageError(res.data.msg);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        _this.$router.push("/login");
      }
    },
    changhePay(selection) {
      this.totAmount = 0;
      this.payData = [];
      this.isdisabledFn = true;
      let billnoList = [];
      let arrList = selection;
      arrList.forEach((item) => {
        billnoList.push(item.orderNo);
        this.payData.push(item);
        this.totAmount = (
          parseFloat(this.totAmount) + parseFloat(item.amount)
        ).toFixed(2);
      });
      if (this.payData.length > 0) {
        this.isdisabledFn = false;
      }
      this.billno = billnoList.join(",");
    },

    tKHandleBeforeUpload(file) {
      const MAX_LEN = 500;
      const currentLen = (this.tKCourseForm.imageNames || "").length;
      const nextLen = currentLen + (file ? file.name.length + 1 : 0);
      if (this.tKUploadList.length >= 3) {
        this.$Notice.warning({ title: "最多只可以上传3张图片" });
        return false;
      }
      if (nextLen > MAX_LEN) {
        this.$Notice.warning({
          title: "图片路径总长度不能超过 500 个字符",
          desc: `当前已占用 ${currentLen} 个字符，再上传这张将超出限制`,
        });
        return false;
      }
      return true;
    },
    tKHandleSuccess(res, file) {
      file.url = this.imgurl + res.data;
      file.name = res.data;
      this.tKUploadList.push({
        url: file.url,
        name: file.name,
        status: file.status,
      });
      this.tKSyncImageNames();
    },
    tKHandleRemove(file) {
      const idx = this.tKUploadList.indexOf(file);
      if (idx > -1) {
        this.tKUploadList.splice(idx, 1);
      }
      this.tKSyncImageNames();
    },
    tKHandleView(url) {
      window.open(url);
    },
    tKSyncImageNames() {
      const names = this.tKUploadList.map((it) => it.name).filter((s) => s);
      this.tKCourseForm.imageNames = names.join(",");
    },
    canDropCourse(course) {
      const parent = this.myLeassonData.find(s => s.sortYearXq === course.yearXq);
      return course.orderStatus == 2 && parent && parent.isRefund == "1";
    },
    openDropCourse(course) {
      const courseId = course.id;
      const orderId = course.orderId;
      this.tKCourseForm.refundReason = "";
      this.tKCourseForm.imageNames = "";
      this.tKUploadList = [];
      this.tKCourseModal = true;
      this.$nextTick(() => {
        if (this.$refs.tKCourseForm) {
          this.$refs.tKCourseForm.resetFields();
          this.tKCourseForm.id = courseId;
          this.tKCourseForm.orderId = orderId;
        }
      });
    },
    dropCourse(id) {
      //退课
      var _this = this;
      _this.$refs.tKCourseForm.validate((val) => {
        if (val) {
          _this.$http
            .post(
              "retire-school-manage/refund/addSchoolRefund?studentId=" +
                this.$store.state.studentId +
                "&courseId=" +
                this.tKCourseForm.id +
                "&refundReason=" +
                this.tKCourseForm.refundReason +
                "&orderId=" +
                this.tKCourseForm.orderId +
                "&imageNames=" +
                encodeURIComponent(this.tKCourseForm.imageNames || "")
            )
            .then(function (res) {
              if (res.data.status === 2000 || res.data.status === 9000) {
                _this.tKCourseModal = false;
                _this.getCourseData();
                _this.$CustomMessageInfo("提交退课成功!");
                _this.$router.go(0);
              } else {
                _this.$CustomMessageError(res.data.msg);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      });
    },

    //未缴费的课取消
    cancelCourse(id) {
      var _this = this;
      _this.$http
        .post("retire-school-manage/course/cancelOrder?id=" + id)
        .then(function (res) {
          if (res.data.status === 2000) {
            _this.getCourseData();
            _this.$CustomMessageInfo("取消课程成功!");
          } else {
            _this.$CustomMessageError(res.data.msg);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getMyInfo() {
      let _this = this;
      this.$http
        .get("retire-school-manage/personal/getMyInfo", {
          params: {
            studentId: _this.$store.state.studentId,
          },
        })
        .then((res) => {
          if (res.data.status == 2000) {
            _this.baseInfo = res.data.data;
          } else {
            console.log("数据获取失败");
          }
        });
    },
    viewInvoice(value) {
      console.log("value", value);
      let _this = this;
      _this.$http
        .get("retire-school-manage/appPay/getSchoolStudentAppPay", {
          params: {
            orderId: value,
          },
        })
        .then((res) => {
          console.log("res", res);
         // if (res.data.status === 2000 ) {
             if (res.data.status === 2000 && res.data.data.pdfUrl != null) {
          //  window.open( res.data.data.pdfUrl , "_blank" );
    
             // 使用后端代理接口
            // const proxyUrl = encodeURIComponent(res.data.data.pdfUrl);
            // window.open(`/retireSystem/retire-school-manage/orderInvoice/previewInvoicePdf?pdfUrl=${proxyUrl}`, "_blank");
       // const url = "https://cwc.tongji.edu.cn/WF_PRETICKET/fileSystem_getAction.action?seq=720720d8c1a3f2b7ead5cd2f3601136d&minFile=0&type=.pdf&projid=WF_PRETICKET&dest=WF_PZ";
            const proxyUrl = encodeURIComponent(encodeURIComponent(res.data.data.pdfUrl));
            const viewerUrl = `https://tjltb.tongji.edu.cn/retireSchool/pdfjs/web/viewer.html?file=https://tjltb.tongji.edu.cn/retireSystem/retire-school-manage/orderInvoice/previewInvoicePdf?pdfUrl=${proxyUrl}`;
            window.open(viewerUrl, "_blank");
          } else {
            _this.viewInvoiceData = res.data.data;
            if (_this.viewInvoiceData.invoiceType == "2") {
              _this.viewInvoiceData.name =
                res.data.data.orderinfoname + "（个人）";
            }
            _this.visibleInvoiceMsg = true;
          }
        });
    },
    updateInvoiceTitle() {
      var _this = this;

      // 先进行基本表单验证
      _this.$refs.invoiceForm.$refs.formInvoice.validate((valid) => {
        if (!valid) {
          _this.$Message.error('请检查表单数据是否正确');
          return;
        }
        
        // 获取表单数据
        var invoiceData = _this.$refs.invoiceForm.formInvoice;
        
        // 如果是单位发票，额外验证纳税人识别号格式
        if (invoiceData.changeRadio == "2") {
          if (!invoiceData.dutyNo) {
            _this.$Message.error('纳税人识别号不能为空');
            return;
          }
          
          // 统一社会信用代码（18位）正则
          const creditCodeReg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
          // 旧税号（15位）正则
          const oldTaxNoReg = /^\d{15}$/;
          
          if (!creditCodeReg.test(invoiceData.dutyNo) && !oldTaxNoReg.test(invoiceData.dutyNo)) {
            _this.$Message.error('请输入正确的纳税人识别号');
            return;
          }
        }
        
        // 所有验证通过后执行提交逻辑
        console.log("invoiceForm", invoiceData);
        let url =
          `retire-school-manage/orderInvoice/updateInvoiceTitle?` +
          `batchOrderNo=${invoiceData.batchOrderNo}` +
          `&invoiceType=${invoiceData.changeRadio}` +
          (invoiceData.changeRadio == "1"
            ? `&invoiceName=${invoiceData.name}` +
              `&remark=${invoiceData.remarks}`
            : `&invoiceName=${invoiceData.companyName}` +
              `&remark=${invoiceData.remarks}` +
              `&dutyNo=${invoiceData.dutyNo}` +
              (invoiceData.buyerAddress
                ? `&buyerAddress=${invoiceData.buyerAddress}`
                : "") +
              (invoiceData.buyerPhone
                ? `&buyerPhone=${invoiceData.buyerPhone}`
                : "") +
              (invoiceData.buyerBankName
                ? `&buyerBankName=${invoiceData.buyerBankName}`
                : "") +
              (invoiceData.buyerBankAccount
                ? `&buyerBankAccount=${invoiceData.buyerBankAccount}`
                : "")) +
          `&phone=${invoiceData.phone}` +
          `&email=${invoiceData.email}`;
        _this.$http
          .post(url)
          .then(function (res) {
            if (res.data.status === 2000) {
              console.log(res.data.data);
              _this.$Message.info("更新成功");
              _this.visibleInvoiceMsg = false;
            } else {
              _this.$Message.error("更新失败");
            }
          })
          .catch();
      });
    },
    // 处理移动端课程选择
    handleMobileSelection(checked, course) {
      let selection = this.myLeassonData[0].myCourselist.filter(item => item.selected);
      
      this.totAmount = 0;
      this.payData = [];
      this.isdisabledFn = true;
      let billnoList = [];
      
      selection.forEach((item) => {
        billnoList.push(item.orderNo);
        this.payData.push(item);
        this.totAmount = (parseFloat(this.totAmount) + parseFloat(item.amount)).toFixed(2);
      });
      
      if (this.payData.length > 0) {
        this.isdisabledFn = false;
      }
      
      this.billno = billnoList.join(",");
    },
    selectAll() {
      this.isAllSelected = !this.isAllSelected;
      if (this.myLeassonData && this.myLeassonData.length > 0) {
        const firstSemester = this.myLeassonData[0];
        if (firstSemester.myCourselist) {
          firstSemester.myCourselist.forEach(course => {
            if (!course._disabled) {
              course.selected = this.isAllSelected;
            }
          });
          // 触发选择变更处理
          this.handleMobileSelection();
        }
      }
    },
  },

  mounted() {
    this.getCourseData();
    this.$http
      .get("/retire-school-manage/config/prohibitPayment")
      .then((res) => {
        this.prohibitPayment = res.data.data;
      });
  },
  created() {
    this.checkIsMobile();
    window.addEventListener("resize", this.checkIsMobile);
    this.getMyInfo();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkIsMobile);
  },
  computed: {
    modalWidth() {
      return this.isMobile ? "92%" : "40%";
    },
    formLabelWidth() {
      return this.isMobile ? 70 : 180;
    },
    labelPosition() {
      return this.isMobile ? "top" : "left";
    },
  },
};
</script>
<style>
/* 添加全局样式覆盖 */
@media screen and (max-width: 768px) {
  #app .content-body {
    width: 100% !important;
    min-width: unset !important;
    padding: 0 !important;
  }
  
  #app .content-wrapper {
    width: 100% !important;
    min-width: unset !important;
  }

  #app .content {
    width: 100% !important;
    min-width: unset !important;
  }

  #app .content-height-body {
    width: 100% !important;
    min-width: unset !important;
  }
}

.mainBox {
  width: 100%;
  max-width: 1400px;
  margin: auto;
  padding: 0 15px;
  box-sizing: border-box;
  background: #fff;
}

.title-wrapper {
  padding: 20px 0;  /* 增加内边距 */
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;  /* 添加底部边框 */
}

.title-wrapper h1 {
  margin: 0;
  color: #333;  /* 添加标题颜色 */
}

/* 退课弹框上传图片预览样式 */
.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
.ivu-icon-ios-cloud-upload {
  color: #5fb878 !important;
}

/* PC端表格样式 */
.pc-table {
  display: block;
  margin: 20px 0;  /* 添加外边距 */
}

@media screen and (max-width: 768px) {
  .pc-table {
    display: none;
  }
  
  .mobile-list {
    display: block;
  }
}

@media screen and (min-width: 769px) {
  .pc-table {
    display: block;
  }
  
  .mobile-list {
    display: none;
  }
}

.pay-button {
  padding: 8px 30px;
  font-size: 20px;
}

/* 移动端样式 */
.mobile-list {
  display: none;
}

.course-card {
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.course-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.course-name {
  margin-left: 10px;
  font-weight: bold;
  font-size: 16px;
  flex: 1;
  word-break: break-all;
}

.course-info {
  margin-bottom: 15px;
}

.info-item {
  display: flex;
  margin-bottom: 8px;
  font-size: 14px;
}

.info-item .label {
  color: #666;
  min-width: 80px;
  flex-shrink: 0;
}

.info-item .value {
  color: #333;
  flex: 1;
  word-break: break-all;
}

.course-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.course-actions button {
  margin: 0 !important;
  flex: 1;
  min-width: calc(45% - 4px); /* 确保每行最多两个按钮 */
  max-width: calc(45% - 4px);
  white-space: nowrap;
  font-size: 18px;
}

@media screen and (max-width: 480px) {
  .course-actions button {
    min-width: calc(50% - 4px); /* 在更小的屏幕上保持两列布局 */
  }
}

/* Modal 样式优化 */
.ivu-modal {
  top: 50px;
}

/* 响应式布局 */
@media screen and (max-width: 768px) {
  .mainBox {
    padding: 10px;
    margin: 0;
  }

  .title-wrapper {
    flex-direction: row;  /* 改回水平布局 */
    justify-content: space-between;  /* 两端对齐 */
    align-items: center;  /* 垂直居中 */
    padding: 15px 0;
  }

  .title-wrapper h1 {
    font-size: 20px;
    margin: 0;
    flex: 1;  /* 让标题占据剩余空间 */
  }

  .title-wrapper span {
    width: auto;  /* 移除宽度限制 */
  }

  .pay-button {
    padding: 4px 15px;
    font-size: 14px;
    white-space: nowrap;  /* 防止文字换行 */
    margin-right: 20px;
  }
  
  .pc-table {
    display: none;
  }
  
  .mobile-list {
    display: block;
    width: 100%;
  }

  .course-card {
    margin: 10px 0;
    border-radius: 4px;
  }

  .info-item {
    display: flex;
    flex-direction: row;  /* 改回行布局 */
    margin-bottom: 8px;
    align-items: flex-start;
  }

  .info-item .label {
    min-width: 70px;  /* 减小标签宽度 */
    margin-bottom: 0;  /* 移除底部间距 */
    flex-shrink: 0;
    padding-right: 8px;  /* 添加右侧间距 */
  }

  .info-item .value {
    flex: 1;
    padding-left: 0;
    word-break: break-all;  /* 确保长文本会换行 */
  }

  .course-actions {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 480px) {
  .mainBox {
    padding: 5px;
  }

  .course-card {
    padding: 10px;
  }

  .course-name {
    font-size: 16px;
  }

  .info-item {
    font-size: 13px;
  }

  .info-item .label {
    min-width: 65px;  /* 在更小屏幕上进一步减小标签宽度 */
  }
}

.select-all-button {
  display: none; /* 默认在PC端隐藏 */
}

@media screen and (max-width: 768px) {
  .select-all-button {
    display: inline-block; /* 在移动端显示 */
  }
}

.tui-uploader {
  display: inline-block;
  vertical-align: middle;
}
.tui-upload-btn {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border: 1px dashed #dcdee2;
  border-radius: 4px;
  background: #fff;
  color: #5fb878;
  cursor: pointer;
  transition: border-color 0.2s;
}
.tui-upload-btn:hover {
  border-color: #5fb878;
}
.tui-upload-text {
  margin-left: 8px;
  font-size: 14px;
  color: #5fb878;
}
.tui-form-actions {
  text-align: right;
  margin-bottom: 0;
}
.tui-action-btn {
  min-width: 96px;
}
.tui-action-cancel {
  margin-left: 16px;
}
.tui-action-primary {
  margin-right: 0;
}
.tui-modal-footer {
  display: flex;
  gap: 16px;
  justify-content: flex-end;
}
.tui-modal-footer .tui-action-cancel {
  margin-left: 0;
}
@media screen and (max-width: 768px) {
  .tui-tk-modal .ivu-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
  }
  .tui-tk-modal .ivu-modal-content {
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 92% !important;
    max-width: 92%;
    max-height: 88vh;
    overflow: hidden;
    border-radius: 8px;
  }
  .tui-tk-modal .ivu-form-item-error-tip {
    padding-top: 6px;
    padding-bottom: 14px;
  }
  .tui-tk-modal .ivu-modal-body {
    padding: 14px 12px 18px;
    max-height: 70vh;
    overflow-y: auto;
  }
  .tui-tk-modal .ivu-form .ivu-form-item-label {
    padding-right: 8px !important;
    white-space: nowrap;
  }
  .tui-tk-modal .ivu-form-item-content {
    margin-left: 0 !important;
  }
  .tui-upload-wrap {
    gap: 6px;
    justify-content: flex-start;
  }
  .tui-uploader,
  .tui-uploader .ivu-upload {
    text-align: left;
    display: inline-block;
    vertical-align: top;
  }
  .tui-form-actions {
    text-align: right;
  }
  .tui-form-actions .ivu-form-item-content {
    margin-left: 0 !important;
    display: flex;
    gap: 12px;
    justify-content: flex-end;
  }
  .tui-action-btn {
    flex: 0 0 auto;
    min-width: 96px;
  }
  .tui-action-cancel {
    margin-left: 0;
  }
  .tui-modal-footer {
    gap: 12px;
  }
}
</style>
